
  import {Component, Vue} from 'vue-property-decorator';
  import {bus} from "@/plugins/bus";
  import CarsUnionRow from "@/modules/CarList/components/carsUnion/CarsUnionRow.vue";
  import {ICarUnion} from "@/modules/CarList/interfaces/car-union.interface";
  import {IBook} from "@/interfaces/book.interface";
  import CarListEmpty from "@/modules/CarList/components/CarListEmpty.vue";

  @Component({
    components: {
      CarsUnionRow,
      CarListEmpty,
    },
  })
  export default class CarsUnion extends Vue {
    activeRow = null;

    get cellProps(): ICarUnion.ITableCell[] {
      return [
        {
          label: 'Машины',
          prop: 'custom-cars',
          propType: ICarUnion.PropType.SubProps,
          subProps: [
            { prop: 'car1Number', propType: ICarUnion.PropType.Input, placeholder: 'Номер машины', },
            { prop: 'car2Number', propType: ICarUnion.PropType.Input, placeholder: 'Номер машины', },
            { prop: 'car3Number', propType: ICarUnion.PropType.Input, placeholder: 'Номер машины', },
            { prop: 'car4Number', propType: ICarUnion.PropType.Input, placeholder: 'Номер машины', },
          ],
        },
        {
          label: 'Корпорация<br> Email',
          prop: 'custom-corp',
          propType: ICarUnion.PropType.SubProps,
          subProps: [
            { prop: 'corpName', propType: ICarUnion.PropType.Input, placeholder: 'Корпорация (логин)', },
            { prop: 'email', propType: ICarUnion.PropType.Input, placeholder: 'Email', },
          ],
        },
        {
          label: 'ФИО<br>Телефон',
          prop: 'custom-person',
          propType: ICarUnion.PropType.SubProps,
          subProps: [
            { prop: 'personName', propType: ICarUnion.PropType.Input, placeholder: 'ФИО', },
            { prop: 'phone', propType: ICarUnion.PropType.Input, placeholder: 'Телефон', },
          ],
        },
        {
          label: 'Парковка<br>Комментарий',
          prop: 'custom-parks',
          propType: ICarUnion.PropType.SubProps,
          subProps: [
            { prop: 'parks', propType: ICarUnion.PropType.Select, titleProp: 'parksNames', options: this.parksOptions, multiple: true, placeholder: 'Парковка', },
            { prop: 'comment', propType: ICarUnion.PropType.Textarea, placeholder: 'Комментарий', },
          ],
        },
        {
          label: 'Долг<br>Последний заезд',
          prop: 'custom-info',
          propType: ICarUnion.PropType.SubProps,
          subProps: [
            { prop: 'saldo', propType: ICarUnion.PropType.NumberFormatted, },
            { prop: 'lastCarMovs', propType: ICarUnion.PropType.DateText, },
          ],
        },
      ];
    }

    get loading() { return this.$store.state.carList.loading; }
    get carUnionList() { return this.$store.state.carList.carUnionList; }

    get parksOptions() { return this.$store.state.book.books[IBook.BookName.parks]; }

    async mounted() {
      bus.$on(ICarUnion.EmitterEvents.ActivateNewRow, () => this.activateRow(0));
    }

    activateRow(index) {
      this.activeRow = index;
    }

    destroyed() {
      bus.$off(ICarUnion.EmitterEvents.ActivateNewRow);
    }
  }
